import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { Workspaces } from './pages/Workspaces';
import { WorkspaceDetail } from './pages/WorkspaceDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Demos } from './pages/Demos';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Legal } from './pages/Legal';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjzlp1wudjkz">
      <Routes data-id="element-1" data-mp="31agoaol7qfjg">
        <Route element={<SiteLayout data-id="element-3" data-mp="31brzvakwgrl4" />} data-id="element-2" data-mp="31aysc7e49y1x">
          <Route path="/" element={<Home data-id="element-5" data-mp="31cjk5p91r2w3" />} data-id="element-4" data-mp="31c1j8fbfw0hu" />
          <Route path="/workspaces" element={<Workspaces data-id="element-7" data-mp="2wj8evsjvuu6a" />} data-id="element-6" data-mp="2wjgrdjc3fxgy" />
          <Route path="/workspaces/:slug" element={<WorkspaceDetail data-id="element-9" data-mp="28tw3qn4zwc1c" />} data-id="element-8" data-mp="2whxabqim5ie4" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-11" data-mp="28s30zixi6bym" />} data-id="element-10" data-mp="28suu8n3mnxlq" />
          <Route path="/demos" element={<Demos data-id="element-13" data-mp="23ujl6el5pr4k" />} data-id="element-12" data-mp="23vupcfiil0w7" />
          <Route path="/about" element={<About data-id="element-15" data-mp="3ik7gihlkcdr6" />} data-id="element-14" data-mp="23t8hsfvmildz" />
          <Route path="/contact" element={<Contact data-id="element-17" data-mp="3ijfunyhrpue3" />} data-id="element-16" data-mp="3ikqy1x7ax04o" />
          <Route path="/privacy" element={<Legal kind="privacy" data-id="element-19" data-mp="3ml12v6jcxkhy" />} data-id="element-18" data-mp="3ii4s22026sok" />
          <Route path="/terms" element={<Legal kind="terms" data-id="element-21" data-mp="3mj6jvxrnc2gi" />} data-id="element-20" data-mp="3mjzuj9tq7c3x" />
          <Route path="*" element={<NotFound data-id="element-23" data-mp="3rdkh85pvcjnt" />} data-id="element-22" data-mp="3rbzmog3k10py" />
        </Route>
      </Routes>
    </BrowserRouter>;
}